import { IAllBotsPage } from '@gem/models/botCatalogModel';
import { ICursorRequest } from '@gem/models/commonModel';

import { botCatalogModel } from 'APP//model/model';

const DEFAULT_LIMIT = 20;

export async function getAllBots(data: ICursorRequest = {}): Promise<IAllBotsPage> {
  try {
    return await botCatalogModel.getAllBots({
      ...data,
      limit: data.limit || DEFAULT_LIMIT,
    });
  } catch {
    return {
      bots: [],
      cursor: undefined,
    };
  }
}
